<template>
    <component
        :is="tag"
        class="container"
        :class="containerClasses">
        <!-- @slot Слот по-умолчанию -->
        <slot></slot>
</component>
</template>

<script>

/**
 * `<SbsContainer>` - это основной контейнер макета. По-умолчанию идет с фиксированной шириной (максимальная ширина изменяется в каждом брейкпоинте). Можно сделать его тянущимся, добавив пропсу `fluid`
 */
export default {
    name: 'SbsContainer',
    computed: {
        containerClasses() {
            if (!this.fluid) return '';

            if (typeof this.fluid === 'boolean') return 'container-fluid';

            return `container-${this.fluid}`;
        },
    },
    props: {
        /**
         * Установливает контейнеру ширину 100% до тех пор, пока не будет достигнут брейкпоинт, в котором применяется максимальная ширина.
         *
         * Например, установка `fluid` на `md` отрендерит контейнер шириной 100% до тех пор, пока не будет достигнут брейкпоинт `md`, после чего он станет стандартным не тянущимся контейнером.
         */
        fluid: {
            type: [Boolean, String],
            default: false,
        },
        /**
         * Определяет тег HTML для контейнера
         */
        tag: {
            type: String,
            default: 'div',
        },
    },
};
</script>
